import React from 'react';
import { Link } from 'react-router-dom';
import './Training.css';
import { PageTitle } from '../../components';
import { training, titles } from '../../constants'; 
import { FaArrowRight, FaClock} from 'react-icons/fa';

import { useTranslation } from 'react-i18next';

const Training = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageTitle title={t('titles.training')} page={t('titles.subTitleTraining')} />

            <section className='training-list-section'>
                <div className='training-grid'>
                    {training.map((item) => (
                        <div key={item.id} className='training-card'>
                            
                            {/* Obrazek karty */}
                            <div className='card-image'>
                                <img src={item.image} alt={t(item.title)} />
                                <div className='card-category'>{item.details.level}</div>
                            </div>

                            {/* Treść karty */}
                            <div className='card-content'>
                                <h3 className='card-title'>{t(item.title)}</h3>
                                <p className='card-desc'>
                                    {t(item.subtitle).substring(0, 100)}...
                                </p>
                                
                                <div className='card-meta'>
                                    <span><FaClock /> {t(item.details.duration)}</span>
                                </div>

                                <Link to={`/Szkolenia/${item.id}`} className='btn-details'>
                                    Szczegóły <FaArrowRight className='icon-arrow' />
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </>
    );
};

export default Training;